import EventSelect from "./events-select";

export default EventSelect;